"use client";

import dynamic from "next/dynamic";

import { HourglassMarkStatic } from "@/components/global/HourglassMarkStatic";
import "@/components/global/mobile-blocker.css";

const MobileBlockerActions = dynamic(
  () =>
    import("@/components/global/MobileBlockerActions").then(
      (m) => m.MobileBlockerActions,
    ),
  { ssr: false },
);

const MobileBlockerHourglass = dynamic(
  () =>
    import("@/components/global/MobileBlockerHourglass").then(
      (m) => m.MobileBlockerHourglass,
    ),
  { ssr: false, loading: () => <HourglassMarkStatic /> },
);

/** Mobile-only gate (<768px). Desktop shell is not rendered for mobile UA (see root layout). */
export function MobileBlocker() {
  return (
    <div className="mobile-blocker">
      <div className="mobile-blocker__glow" aria-hidden />

      <div className="mobile-blocker__panel">
        <div className="mobile-blocker__icon-wrap">
          <MobileBlockerHourglass />
        </div>

        <div className="mobile-blocker__body">
          <h2 className="mobile-blocker__heading">
            The full experience lives on desktop.
          </h2>
          <MobileBlockerActions />
        </div>
      </div>
    </div>
  );
}
